export enum FeatureFlagKeys {
    NewAddCreditCardFlow = 'ff_new_add_credit_card_flow',
    NewAuthPagerModal = 'ff_new_auth_pager_modal',
}
// TODO: Add feature flags here
// NewItemPageLayout = 'ff_laac-5678_new-item-page-layout',

export type FeatureFlags = Partial<Record<FeatureFlagKeys, boolean>>;
